<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card title="Master Role">
      <!-- <b-card-text>Role.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Role -->
            <b-col cols="12">
              <b-form-group
                label="Role"
                label-for="v-role"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <b-form-input
                    id="v-role-name"
                    v-model="form.text_1"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Role"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group
                label="Desc"
                label-for="v-desc"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Desc"
                >
                  <b-form-input
                    id="v-desc"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Desc"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- PERMISSION TABLE -->
            <b-col cols="12">
              <b-card-header class="p-1">
                <b-card-title class="font-medium-2">
                  <feather-icon
                    icon="LockIcon"
                    size="18"
                  />
                  <span class="align-middle ml-50">Permission</span>
                </b-card-title>
              </b-card-header>
              <b-table-simple
                responsive
                class="mb-0"
              >
                <b-thead>
                  <b-tr>
                    <b-th colspan="5">
                      Name
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <template v-for="(r_PrivilegeCategory, index) in Privilege">
                    <b-td>
                      <b-form-checkbox
                        v-model="form.privilege_category"
                        :value="r_PrivilegeCategory.id"
                        :disabled="form.privilege_category.includes(r_PrivilegeCategory.id) === false"
                        @change="() => checklistPrivilegeCategory(r_PrivilegeCategory.id)"
                      >
                        {{ r_PrivilegeCategory.name }}
                      </b-form-checkbox>
                    </b-td>
                    <b-tr :key="index">
                      <b-col>
                        <template v-for="(r_Privilege, index) in r_PrivilegeCategory.privileges">
                          <template>
                            <b-td :key="index">
                              <b-form-checkbox
                                v-model="form.role_privilege"
                                :value="{
                                  id: r_Privilege.id,
                                  privilege_category_id: r_Privilege.privilege_category_id,
                                  parent: r_Privilege.parent_id
                                }"
                                @change="() => checklistPrivilege(r_Privilege.privilege_category_id)"
                              >
                                {{ r_Privilege.name }}
                              </b-form-checkbox>
                            </b-td>
                          </template>
                        </template>
                      </b-col>
                    </b-tr>
                    <b-tr>
                      <template v-for="(r_Privilege_c, index) in r_PrivilegeCategory.privilege_category">
                        <div class="ml-2">
                          <b-td :key="index">
                            <b-form-checkbox
                              v-model="form.privilege_category"
                              :value="r_Privilege_c.id"
                              :disabled="form.privilege_category.includes(r_Privilege_c.id) === false"
                              @change="() => checklistPrivilegeCategory(r_Privilege_c.id)"
                            >
                              {{ r_Privilege_c.name }}
                            </b-form-checkbox>
                          </b-td>
                        </div>
                        <template v-for="r_Privilege_c_p in r_Privilege_c.privileges">
                          <div class="ml-3 col">
                            <template>
                              <b-td>
                                <b-form-checkbox
                                  v-model="form.role_privilege"
                                  :value="{
                                    id: r_Privilege_c_p.id,
                                    privilege_category_id: r_Privilege_c_p.privilege_category_id,
                                    parent: r_Privilege_c_p.parent_id
                                  }"
                                  @change="() => checklistPrivilege(r_Privilege_c_p.privilege_category_id, r_PrivilegeCategory.privileges)"
                                >
                                  {{ r_Privilege_c_p.name }}
                                </b-form-checkbox>
                              </b-td>
                            </template>
                          </div>
                          <div class="ml-4 col">
                            <template v-for="r_Privilege_c_level in r_Privilege_c.privilege_category">
                              <b-col>
                                <b-td>
                                  <b-form-checkbox
                                    v-model="form.privilege_category"
                                    :value="r_Privilege_c_level.id"
                                    :disabled="form.privilege_category.includes(r_Privilege_c_level.id) === false"
                                    @change="() => checklistPrivilegeCategory(r_Privilege_c_level.id)"
                                  >
                                    {{ r_Privilege_c_level.name }}
                                  </b-form-checkbox>
                                </b-td>
                              </b-col>
                              <template v-for="r_Privilege_c_level_p in r_Privilege_c_level.privileges">
                                <div class="ml-4">
                                  <b-td>
                                    <b-form-checkbox
                                      v-model="form.role_privilege"
                                      :value="{
                                        id: r_Privilege_c_level_p.id,
                                        privilege_category_id: r_Privilege_c_level_p.privilege_category_id,
                                        parent: r_Privilege_c_level_p.parent_id
                                      }"
                                      @change="() => checklistPrivilege(r_Privilege_c_level_p.privilege_category_id, r_Privilege_c.privileges, r_PrivilegeCategory.privileges)"
                                    >
                                      {{ r_Privilege_c_level_p.name }}
                                    </b-form-checkbox>
                                  </b-td>
                                </div>
                              </template>
                            </template>
                          </div>
                        </template>
                      </template>
                    </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <div><div class="h-50 d-inline-block" /></div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BThead, BTr, BTh, BTd, BTbody, BTableSimple, BTable, BOverlay, BCol, BCardHeader, BFormGroup, BCardTitle, BFormInput, BForm, BFormCheckbox, BButton, BCard,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapState } from 'vuex'

export default {
  components: {
    BOverlay, ValidationProvider, ValidationObserver, BThead, BTr, BTh, BTd, BTbody, BTableSimple, BTable, BCard, BCardHeader, BCardTitle, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BForm, BButton,
  },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, text_1: '', text_2: '', role_privilege: [], privilege_category: [],
      },
      show: false,
      required,
      checkbox1: false,
    }
  },
  computed: {
    ...mapState({
      PrivilegeCategory: state => state.privilegeCategory.items,
      Privilege: state => state.privilegeCategory.itemsTree,
    }),
  },
  watch: {
    checkbox1(value) {
      if (!value) {
        this.form.role_privilege = false
      }
    },
  },
  created() {
    this.$store.dispatch('privilegeCategory/getAllTree')
  },
  mounted() {
    // console.log(this.PrivilegeCategory)
    // console.log(this.Privilege)
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  },
  methods: {
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.form
			    this.$store.dispatch('role/formPostPut', formData)
              .then(res => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
              },
              err => {
                this.show = false
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    removeValueFromArray(array, valueToRemove) {
      // Find the index of the value to remove
      const index = array.indexOf(valueToRemove)

      // If the value exists in the array
      if (index !== -1) {
        // Create a new array without the value
        return array.filter(item => item !== valueToRemove)
        // Alternatively, you could modify the original array with:
        // array.splice(index, 1);
        // return array;
      }

      // Return the original array if the value wasn't found
      return array
    },
    checklistPrivilege(privilegeCategoryId, parent, root) {
      const privilegeExist = this.form.role_privilege.find(x => x.privilege_category_id === privilegeCategoryId)
      if (privilegeExist === undefined) {
        this.form.privilege_category = this.removeValueFromArray(this.form.privilege_category, privilegeCategoryId)
      } else {
        this.form.privilege_category.push(privilegeCategoryId)
      }

      if (parent) {
        const selectedParent = parent?.[0]
        const parentExist = this.form.role_privilege.find(x => x.id === selectedParent?.id)
        if (parentExist === undefined) {
          this.form.role_privilege.push({
            id: selectedParent.id,
            privilege_category_id: selectedParent.privilege_category_id,
            parent: selectedParent.parent_id,
          })

          this.checklistPrivilege(selectedParent.privilege_category_id)
        }
      }

      if (root) {
        const selectedRoot = root?.[0]
        const rootExist = this.form.role_privilege.find(x => x.id === selectedRoot?.id)
        if (rootExist === undefined) {
          this.form.role_privilege.push({
            id: selectedRoot.id,
            privilege_category_id: selectedRoot.privilege_category_id,
            parent: selectedRoot.parent_id,
          })

          this.checklistPrivilege(selectedRoot.privilege_category_id)
        }
      }
    },
    checklistPrivilegeCategory(privilegeCategoryId) {
      const privilegeCategoryExist = this.form.privilege_category.includes(privilegeCategoryId)
      console.log(privilegeCategoryExist)
      if (!privilegeCategoryExist) {
        this.form.role_privilege = this.form.role_privilege.filter(x => x.privilege_category_id !== privilegeCategoryId)
      }
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    getData(id) {
      this.$store.dispatch('role/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.desc
        for (let is = 0, s = data.role_privileges.length; is < s; is++) {
          const rolePrivilege = data.role_privileges[is]
          this.form.role_privilege.push(
            {
              id: rolePrivilege.privilege_id,
              privilege_category_id: rolePrivilege?.privileges?.privilege_category_id,
              parent: undefined,
            },
          )
          this.form.privilege_category.push(rolePrivilege?.privileges?.privilege_category_id)
        }
        this.show = false
      })
    },
  },
}
</script>
